<!-- START: forms/internal assets -->
<section class="card  mt-4 key-ratios">
  <button _ngcontent-c3="" aria-label="Close" class="close" data-dismiss="modal" type="button">
      <span _ngcontent-c3="" aria-hidden="true">×</span>
  </button>
  <div class="nav-tabs-horizontal">
      <ul class="nav nav-tabs inverse" role="tablist">
          <li class="nav-item">
              <a class="nav-link active" data-target="#earningsRatiosTab" data-toggle="tab" href="javascript: void(0);" role="tab" aria-expanded="true"
                  (click)="tagToogle('earningsRatiosTab')">Earnings Ratios</a>
          </li>
          <li class="nav-item">
              <a class="nav-link" data-target="#marginRatiosTab" data-toggle="tab" href="javascript: void(0);" role="tab" aria-expanded="false"
                  (click)="tagToogle('marginRatiosTab')">Margin Ratios</a>
          </li>
          <li class="nav-item">
              <a class="nav-link" data-target="#growthRatiosTab" data-toggle="tab" href="javascript: void(0);" role="tab" aria-expanded="false"
                  (click)="tagToogle('growthRatiosTab')">Growth Ratios</a>
          </li>
          <li class="nav-item">
              <a class="nav-link" data-target="#returnsRatiosTab" data-toggle="tab" href="javascript: void(0);" role="tab" aria-expanded="false"
                  (click)="tagToogle('returnsRatiosTab')">Returns Ratios</a>
          </li>
      </ul>
   
 <div class="tab-content">

  <!-- Earnings Ratios -->
  <div class="tab-pane active" id="earningsRatiosTab" role="tabpanel">
    <!-- Charts Section - Show First -->
    <div *ngIf="keyRatiosNewData?.earnings_ratios?.quarter && keyRatiosNewData?.earnings_ratios?.annual" class="mt-3">
      <h5 class="mb-3">Graphical Comparison</h5>
      <div class="row">
        <div class="col-md-6 mb-4">
          <div class="card">
            <div class="card-body">
              <h6 class="card-title text-center">Quarterly Earnings Ratios</h6>
              <div style="position: relative; height: 350px;">
                <canvas id="quarterlyEarningsChart"></canvas>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6 mb-4">
          <div class="card">
            <div class="card-body">
              <h6 class="card-title text-center">Annual Earnings Ratios</h6>
              <div style="position: relative; height: 350px;">
                <canvas id="annualEarningsChart"></canvas>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Tables Section - Show After Charts -->
    <h5 class="mt-4">Quarterly Earnings Ratios</h5>
    <table *ngIf="keyRatiosNewData?.earnings_ratios?.quarter" class="table table-bordered">
      <tr><th>Price to Earnings</th><td>{{ keyRatiosNewData.earnings_ratios.quarter.price_to_earnings_ratio  | number:'1.2-2'}}</td></tr>
      <tr><th>Earnings per Share</th><td>{{ keyRatiosNewData.earnings_ratios.quarter.earnings_per_share | number:'1.2-2' }}</td></tr>
      <tr><th>Dividend per Share</th><td>{{ keyRatiosNewData.earnings_ratios.quarter.dividend_per_share | number:'1.2-2' }}</td></tr>
      <tr><th>Dividend Yield (%)</th><td>{{ keyRatiosNewData.earnings_ratios.quarter.dividend_yield_percentage | number:'1.2-2' }}</td></tr>
    </table>

    <h5 class="mt-3">Annual Earnings Ratios</h5>
    <table *ngIf="keyRatiosNewData?.earnings_ratios?.annual" class="table table-bordered">
      <tr><th>Price to Earnings</th><td>{{ keyRatiosNewData.earnings_ratios.annual.price_to_earnings_ratio  | number:'1.2-2' }}</td></tr>
      <tr><th>Earnings per Share</th><td>{{ keyRatiosNewData.earnings_ratios.annual.earnings_per_share | number:'1.2-2' }}</td></tr>
      <tr><th>Dividend per Share</th><td>{{ keyRatiosNewData.earnings_ratios.annual.dividend_per_share | number:'1.2-2' }}</td></tr>
      <tr><th>Dividend Yield (%)</th><td>{{ keyRatiosNewData.earnings_ratios.annual.dividend_yield_percentage | number:'1.2-2' }}</td></tr>
    </table>
  </div>

  <!-- Margin Ratios -->
  <div class="tab-pane" id="marginRatiosTab" role="tabpanel">
    <!-- Charts Section - Show First -->
    <div *ngIf="keyRatiosNewData?.margin_ratios?.quarter && keyRatiosNewData?.margin_ratios?.annual" class="mt-3">
      <h5 class="mb-3">Graphical Comparison</h5>
      <div class="row">
        <div class="col-md-6 mb-4">
          <div class="card">
            <div class="card-body">
              <h6 class="card-title text-center">Quarterly Margin Ratios</h6>
              <div style="position: relative; height: 350px;">
                <canvas id="quarterlyMarginChart"></canvas>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6 mb-4">
          <div class="card">
            <div class="card-body">
              <h6 class="card-title text-center">Annual Margin Ratios</h6>
              <div style="position: relative; height: 350px;">
                <canvas id="annualMarginChart"></canvas>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Tables Section - Show After Charts -->
    <h5 class="mt-4">Quarterly Margin Ratios</h5>
    <table *ngIf="keyRatiosNewData?.margin_ratios?.quarter" class="table table-striped">
      <tr><th>Gross Profit Margin</th><td>{{ keyRatiosNewData.margin_ratios.quarter.gross_profit_margin | number:'1.2-2' }}</td></tr>
      <tr><th>Operating Profit Margin</th><td>{{ keyRatiosNewData.margin_ratios.quarter.operating_profit_margin | number:'1.2-2' }}</td></tr>
      <tr><th>Net Profit Margin</th><td>{{ keyRatiosNewData.margin_ratios.quarter.net_profit_margin | number:'1.2-2' }}</td></tr>
      <tr><th>EBITDA Margin</th><td>{{ keyRatiosNewData.margin_ratios.quarter.ebitda_margin | number:'1.2-2' }}</td></tr>
    </table>

    <h5 class="mt-3">Annual Margin Ratios</h5>
    <table *ngIf="keyRatiosNewData?.margin_ratios?.annual" class="table table-striped">
      <tr><th>Gross Profit Margin</th><td>{{ keyRatiosNewData.margin_ratios.annual.gross_profit_margin | number:'1.2-2' }}</td></tr>
      <tr><th>Operating Profit Margin</th><td>{{ keyRatiosNewData.margin_ratios.annual.operating_profit_margin | number:'1.2-2' }}</td></tr>
      <tr><th>Net Profit Margin</th><td>{{ keyRatiosNewData.margin_ratios.annual.net_profit_margin | number:'1.2-2' }}</td></tr>
      <tr><th>EBITDA Margin</th><td>{{ keyRatiosNewData.margin_ratios.annual.ebitda_margin | number:'1.2-2' }}</td></tr>
    </table>
  </div>

  <!-- Growth Ratios -->
  <div class="tab-pane" id="growthRatiosTab" role="tabpanel">
    <!-- Charts Section - Show First -->
    <div *ngIf="keyRatiosNewData?.growth_ratios?.annual" class="mt-3">
      <h5 class="mb-3">Graphical Comparison</h5>
      <div class="row">
        <div class="col-md-12 mb-4">
          <div class="card">
            <div class="card-body">
              <h6 class="card-title text-center">Annual Growth Ratios</h6>
              <div style="position: relative; height: 350px;">
                <canvas id="annualGrowthChart"></canvas>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Tables Section - Show After Charts -->
    <h5 class="mt-4">Annual Growth Ratios</h5>
    <table *ngIf="keyRatiosNewData?.growth_ratios?.annual" class="table table-hover">
      <tr><th>P/E Growth Ratio</th><td>{{ keyRatiosNewData.growth_ratios.annual.price_to_earnings_growth_ratio | number:'1.2-2' }}</td></tr>
      <tr><th>Revenue per Share</th><td>{{ keyRatiosNewData.growth_ratios.annual.revenue_per_share | number:'1.2-2' }}</td></tr>
      <tr><th>Book Value per Share</th><td>{{ keyRatiosNewData.growth_ratios.annual.book_value_per_share | number:'1.2-2' }}</td></tr>
      <tr><th>Free Cash Flow per Share</th><td>{{ keyRatiosNewData.growth_ratios.annual.free_cash_flow_per_share | number:'1.2-2' }}</td></tr>
    </table>
  </div>

  <!-- Returns Ratios -->
  <div class="tab-pane" id="returnsRatiosTab" role="tabpanel">
    <!-- Charts Section - Show First -->
    <div *ngIf="keyRatiosNewData?.returns_ratios?.annual" class="mt-3">
      <h5 class="mb-3">Graphical Comparison</h5>
      <div class="row">
        <div class="col-md-12 mb-4">
          <div class="card">
            <div class="card-body">
              <h6 class="card-title text-center">Annual Returns Ratios</h6>
              <div style="position: relative; height: 350px;">
                <canvas id="annualReturnsChart"></canvas>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Tables Section - Show After Charts -->
    <h5 class="mt-4">Annual Returns Ratios</h5>
    <table *ngIf="keyRatiosNewData?.returns_ratios?.annual" class="table table-hover">
      <tr><th>Return on Assets</th><td>{{ keyRatiosNewData.returns_ratios.annual.return_on_assets | number:'1.2-2' }}</td></tr>
      <tr><th>Current Ratio</th><td>{{ keyRatiosNewData.returns_ratios.annual.current_ratio | number:'1.2-2' }}</td></tr>
      <tr><th>Quick Ratio</th><td>{{ keyRatiosNewData.returns_ratios.annual.quick_ratio | number:'1.2-2' }}</td></tr>
      <tr><th>Debt to Equity Ratio</th><td>{{ keyRatiosNewData.returns_ratios.annual.debt_to_equity_ratio | number:'1.2-2' }}</td></tr>
    </table>
  </div>

</div>

</div>
</section>
<!-- END: forms/internal assets -->